import React from "react";
import ThemeProvider from "@onnit-js/ui/components/themes/ThemeProvider";
import useOnnitContext from "@onnit-js/ui/hooks/useOnnitContext";
import theme from "@onnit-js/ui/components/themes/dark";
import Box from "@onnit-js/ui/components/box/Box";
import { Text } from "@onnit-js/ui/components/text";
import BgImage from "@onnit-js/ui/components/image/BgImage";
import HeadlineLabelContent from "@onnit-js/ui/components/module/HeadlineLabelContent";
import TwelveColumn from "@onnit-js/ui/components/module/grid/12/Grid";
import { Features, Heroes } from "./StoryView";

const yellowish = "#E5D51C";

export default function Page() {
    const onnitContext = useOnnitContext();

    if (!onnitContext) {
        return null;
    }

    const IMG_URL = `${onnitContext.url.cdn.static_images}/landers/onnit-stories/`;
    const IMG_PARAMS = "?q=40&fm=pjpg&auto=compress,format";

    return (
        <ThemeProvider theme={theme}>
            <Box maxWidth="1600px" mx="auto" backgroundColor="black">
                <BgImage
                    lazy={false}
                    backgroundPosition="top left"
                    minHeight={["600px", "600px", "800px", "800px"]}
                    src={[`${IMG_URL}header--mobile.jpg${IMG_PARAMS}`, `${IMG_URL}header--desktop.jpg${IMG_PARAMS}`]}
                />
                <TwelveColumn mb={[3, 6, 6, 8]}>
                    <Box gridColumn={["1 / -1", "1 / -1", "1 / span 12"]}>
                        <HeadlineLabelContent
                            mt={[4, 4, 6, 10]}
                            label={(
                                <Text typeStyle="copy05" color={yellowish}>
                                    Docuseries
                                </Text>
                            )}
                            headline={(
                                <Text as="h1" typeStyle="headlineHero02" fontStyle="normal" color="white">
                                    Onnit Stories
                                </Text>
                            )}
                            content={(
                                <>
                                    <Text as="p" typeStyle="body" color="grays.2" mb={3}>
                                        Everyone loves to hear a good story. A well-told tale is entertaining, appeals
                                        to our values, and inspires us to do something that's worth other people telling
                                        stories about.
                                    </Text>
                                    <Text as="p" typeStyle="body" color="grays.2" mb={3}>
                                        We believe storytelling is the best way to convey how Onnit can help its
                                        community on their path to Total Human Optimization.
                                    </Text>
                                    <Text as="p" typeStyle="body" color="grays.2" mb={3}>
                                        That's why we created Onnit Stories, a live-interview series introducing real
                                        people who have made amazing and positive life changes since discovering our
                                        brand. Many of the storytellers are members of the Onnit Tribe—a private
                                        Facebook group of Onnit fans who support one another’s every move, in and out of
                                        the gym—and they'll tell you in their own words exactly how they've achieved
                                        incredible health, performance, career, and personal goals.
                                    </Text>
                                    <Text as="p" typeStyle="body" color="grays.2" mb={3}>
                                        We hope you'll connect with these stories and be moved… to tears, laughter,
                                        empathy, and, ultimately, to action.
                                    </Text>
                                    <Text as="p" typeStyle="body" color="grays.2">
                                        Action that helps you reach your potential, and write your own story.
                                    </Text>
                                </>
                            )}
                        />
                    </Box>
                </TwelveColumn>

                <Heroes baseUrl={IMG_URL} imgParams={IMG_PARAMS} />
                <TwelveColumn display={["block", "block", "block", "grid"]} px={4}>
                    <Box gridColumn="2 / span 6" pb={[5, 5, 4]}>
                        <Text as="p" typeStyle="body" color="white">
                            You can stay up to date with Onnit Stories by following Onnit's Instagram TV (
                            <Text
                                display="inline"
                                as="a"
                                href="https://www.instagram.com/onnit/channel/?hl=en"
                                typeStyle="body"
                                target="_blank"
                            >IGTV
                            </Text>),
                            where a new one appears every other week.
                        </Text>
                    </Box>
                </TwelveColumn>

                <Features baseUrl={IMG_URL} imgParams={IMG_PARAMS} py={[3, 6, 8]} />
            </Box>
        </ThemeProvider>
    );
}
